import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import './style.css';

const LegacyLoadingSpinner = () => (
  <div className="loading-spinner">
    <CircularProgress color="primary" />
  </div>
);

export default LegacyLoadingSpinner;
